<div class="container">
  <div class="section-intro">
    <h3>{{ content.eval_metrics_headline }}</h3>
    <p>{{ content.eval_metrics_supporting_text }}</p>
  </div>
  <odm-icon-blocks [icons]="content.metrics" [narrow]="true"></odm-icon-blocks>
</div>
